import { formatDate, convertToTimezone } from "@gigpro/utils/datetime";
import type { ConvertibleShift } from "@sidegigllc/api/client";
import { countOf } from "domains/hire/components/ConvertibleShiftList";

/** What Review repeats for converted shifts, each day read at the location: "2 posted shifts become ... Fri, Jun 19 · Sat, Jun 20". */
export const convertSummary = (shifts: Array<Pick<ConvertibleShift, "start_time">>, timezone: string) => {
  const days = shifts.map((shift) => formatDate(convertToTimezone(shift.start_time, timezone), "EEE, MMM d"));
  const verb = shifts.length === 1 ? "becomes" : "become";
  return `${countOf(shifts.length, "posted shift")} ${verb} working interviews: ${days.join(" · ")}`;
};
